import React, {useEffect, useState} from 'react'

import "styles/components/popup.sass"
import "pages/Styles/UIKit_v2.sass"
import "pages/Styles/Cells.sass"
import "pages/Styles/ProfileV2.sass"

import {useMediaQuery} from "@mui/material";
import {useRoute} from "react-router5";
import {connect} from "react-redux";
import IncomingWebhookIntegrationPopup from "./IncomingWebhookIntegrationPopup";
import AmoCRMIntegrationPopup from "./AmoCRMIntegrationPopup";
import BitrixIntegrationPopup from "./BitrixIntegrationPopup";
import RentProgIntegrationPopup from "./RentProgIntegrationPopup";
import {HelpView} from "../../Common/HelpView";
import ApiIntegrationPopup from "./ApiIntegrationPopup"; // новый попап для API-интеграции
import LockIntegrationStubPopup from "./LockIntegrationStubPopup"; // заглушка для замков и опосредованных интеграций
import IntegrationCard from "./IntegrationCard";
import RealtyIntegrationSetupPopup from "./RealtyIntegrationSetupPopup";
import RealtyIntegrationV2Popup from "./RealtyIntegrationV2Popup";
import RoomSharingIntegrationPopup from "./RoomSharingIntegrationPopup";
import YclientsIntegrationPopup from "./YclientsIntegrationPopup";
import ParaplanIntegrationPopup, {PARAPLAN_DOCS_URL} from "./ParaplanIntegrationPopup";
import {YCLIENTS_MARKETPLACE_URL} from "./yclientsMarketplaceCopy";
import { ReactComponent as DigitalConciergeIcon } from 'images/pages/profile/integrations/digital_concierge.svg';
import { ReactComponent as RoomSharingIcon } from 'images/pages/profile/integrations/roomsharing.svg';
import { ReactComponent as YclientsIcon } from 'images/pages/profile/integrations/yclients.svg';
import { ReactComponent as ParaplanIcon } from 'images/pages/profile/integrations/paraplan.svg';
// import { ReactComponent as BnovoIcon } from 'images/pages/profile/integrations/bnovo.svg';
// import { ReactComponent as TravelLineIcon } from 'images/pages/profile/integrations/travelline.svg';
import amoIcon from 'images/pages/profile/integrations/amo.jpg';
import bitrixIcon from 'images/pages/profile/integrations/bitrix.png';
import realtyIcon from 'images/pages/profile/integrations/realty.jpeg';
import litepmsIcon from 'images/pages/profile/integrations/litepms.jpeg';
import rentysoftIcon from 'images/pages/profile/integrations/rentysoft.jpg';
import rentprogIcon from 'images/pages/profile/integrations/rent_prog.png';
import { isRealtySetupQuery, realtySetupRouteParams } from "../profileTabQuery";

let IntegrationsView: any = function IntegrationsView(props: any) {
    const $router = useRoute();
    const [realtyIntegrationPopup, setRealtyIntegrationPopup] = useState(false);
    const [realtyIntegrationInfoPopup, setRealtyIntegrationInfoPopup] = useState(false);
    const [realtyOldIntegrationPopup, setRealtyOldIntegrationPopup] = useState(false);
    // const [litePMSIntegrationPopup, setLitePMSIntegrationPopup] = useState(false);
    const [amoIntegrationPopup, setAmoIntegrationPopup] = useState(false);
    const [bitrixIntegrationPopup, setBitrixIntegrationPopup] = useState(false);
    const [rentprogIntegrationPopup, setRentprogIntegrationPopup] = useState(false);
    const [apiIntegrationPopup, setApiIntegrationPopup] = useState(false);
    const [digitalConciergePopup, setDigitalConciergePopup] = useState(false);
    const [rentySoftPopup, setRentySoftPopup] = useState(false);
    const [roomSharingPopup, setRoomSharingPopup] = useState(false);
    const [yclientsPopup, setYclientsPopup] = useState(false);
    const [paraplanPopup, setParaplanPopup] = useState(false);
    // const [bnovoPopup, setBnovoPopup] = useState(false);
    // const [travelLinePopup, setTravelLinePopup] = useState(false);

    useEffect(() => {
        if (!isRealtySetupQuery($router.route.params.realty_setup)) {
            return
        }
        setRealtyIntegrationPopup(true)
        $router.router.navigate("profile", { tab: realtySetupRouteParams().tab }, { replace: true })
    }, [$router.route.params.realty_setup])

    // Функция для создания обертки иконки
    const createIconWrapper = (icon: React.ReactNode) => (
        <div style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            border: '2px solid #E0E4EA',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fff',
            overflow: 'hidden',
        }}>
            {icon}
        </div>
    );

    function helpViewDescription(serviceName: string) : string {
        return `На каждую новую бронь в ${serviceName} будет создаваться черновик договора в ОкиДоки.` +
            `Все параметры брони и данные клиента из ${serviceName} будут занесены в договор.\n` +
            'По умолчанию с данной интеграцией работает только шаблон "Краткосрочный найм". Если вы настраиваете свой шаблон, то называйте поля так же, как они названы в нашем готовом шаблоне краткосрочного найма.\n'
    }

    // Данные интеграций
    const integrations = {
        api: [
            {
                key: 'api',
                title: 'API интеграция',
                description: 'Интеграция через API для прямого обмена данными с ОкиДоки.',
                icon: <div style={{fontSize: 28, color: '#1FA3EE'}}>API</div>,
                onDetails: () => setApiIntegrationPopup(true),
            },
        ],
        crm: [
            {
                key: 'paraplan',
                title: 'Параплан',
                description: 'CRM для учебных центров и студий. Документ создаётся из карточки ученика по шаблону ОкиДоки: ссылка на подписание уходит клиенту, подписанный PDF сохраняется в Параплане.',
                icon: createIconWrapper(<ParaplanIcon width={40} height={40} />),
                onDetails: () => setParaplanPopup(true),
                onPrimary: () => window.open(PARAPLAN_DOCS_URL, '_blank', 'noopener,noreferrer'),
                primaryLabel: 'Инструкция',
            },
            {
                key: 'yclients',
                title: 'YCLIENTS',
                description: 'Онлайн-запись и карточка клиента. Интеграция добавляет вкладку ОкиДоки в окно записи 2.0: договор создаётся по шаблону, ФИО и телефон подставляются сами, email и доп. поля — если указан User Token филиала.',
                icon: createIconWrapper(<YclientsIcon width={40} height={40} />),
                onDetails: () => setYclientsPopup(true),
                onPrimary: () => window.open(YCLIENTS_MARKETPLACE_URL, '_blank', 'noopener,noreferrer'),
                primaryLabel: 'Открыть в YCLIENTS',
            },
            {
                key: 'bitrix',
                title: 'Bitrix24',
                description: 'Комплексная платформа для управления бизнесом. CRM, задачи, документы, коммуникации в одной системе. Интеграция добавляет виджет ОкиДоки в карточку сделки Bitrix. Договор можно создать прямо из карточки, выбрав шаблон и подписанта.',
                icon: createIconWrapper(<img src={bitrixIcon} alt="Bitrix24" width={40} height={40} style={{objectFit: 'contain'}} />),
                onDetails: () => setBitrixIntegrationPopup(true),
            },
            {
                key: 'amocrm',
                title: 'amoCRM',
                description: 'CRM система для управления продажами и клиентами. Автоматизация бизнес-процессов. Интеграция добавляет виджет ОкиДоки в карточку сделки amoCRM. Договор можно создать прямо из карточки, выбрав шаблон и подписанта.',
                icon: createIconWrapper(<img src={amoIcon} alt="amoCRM" width={40} height={40} style={{objectFit: 'contain'}} />),
                onDetails: () => setAmoIntegrationPopup(true),
            },
            {
                key: 'rentprog',
                title: 'RentProg',
                description: 'CRM-система для прокатного бизнеса. Обеспечивает полный цикл автоматизации от бронирования до финансового учета. Интеграция позволяет мгновенно отправлять электронные версии документов клиентам прямо из аккаунта RentProg.',
                icon: createIconWrapper(<img src={rentprogIcon} alt="RentProg" width={40} height={40} style={{objectFit: 'contain'}} />),
                onDetails: () => setRentprogIntegrationPopup(true),
            },
        ],
        pms: [
            {
                key: 'realty-v2',
                title: 'RealtyCalendar 2.0',
                description: 'Новая интеграция с RealtyCalendar. Работайте с договорами прямо из личного кабинета RealtyCalendar: создавайте их и отслеживайте статусы подписания там же. В договор передаются ключевые данные брони.',
                icon: createIconWrapper(<img src={realtyIcon} alt="RealtyCalendar 2.0" width={40} height={40} style={{objectFit: 'contain'}} />),
                onDetails: () => setRealtyIntegrationInfoPopup(true),
                onPrimary: () => setRealtyIntegrationPopup(true),
            },
            {
                key: 'realty-old',
                title: 'RealtyCalendar (старая интеграция)',
                description: 'Старая интеграция с RealtyCalendar через вебхук. При каждой новой брони в RealtyCalendar в ОкиДоки создаётся черновик договора с данными брони и клиента. Рекомендуем перейти на новую интеграцию RealtyCalendar 2.0.',
                icon: createIconWrapper(<img src={realtyIcon} alt="RealtyCalendar" width={40} height={40} style={{objectFit: 'contain'}} />),
                onDetails: () => setRealtyOldIntegrationPopup(true),
            },
            // {
            //     key: 'litepms',
            //     title: 'LitePMS',
            //     description: 'Система управления недвижимостью для арендного бизнеса. Автоматизация процессов бронирования и управления объектами. Интеграция с LitePMS позволяет автоматически создавать договоры на основе данных PMS.',
            //     icon: createIconWrapper(<img src={litepmsIcon} alt="LitePMS" width={40} height={40} style={{objectFit: 'contain'}} />),
            //     onDetails: () => setLitePMSIntegrationPopup(true),
            // },
            // {
            //     key: 'bnovo',
            //     title: 'Bnovo',
            //     description: 'Система управления отелями и гостиницами. Автоматизация рутины и отчетов, усиление revenue, контроль загрузки и управление бронями. Интеграция через RoomSharing позволяет синхронизировать данные с ОкиДоки.',
            //     icon: createIconWrapper(<BnovoIcon width={40} height={40} />),
            //     onDetails: () => setBnovoPopup(true),
            // },
            // {
            //     key: 'travelline',
            //     title: 'TravelLine',
            //     description: 'Комплексная система управления отелями и туристическими объектами. Автоматизация бронирования, управления номерами и клиентами. Интеграция через RoomSharing обеспечивает синхронизацию с ОкиДоки.',
            //     icon: createIconWrapper(<TravelLineIcon width={40} height={40} />),
            //     onDetails: () => setTravelLinePopup(true),
            // },
        ],
        locks: [
            {
                key: 'digitalconcierge',
                title: 'Digital Concierge',
                description: 'Система управления умными замками для арендного бизнеса. Автоматизация процессов заселения и выезда. Интеграция с различными PMS системами. Удаленное управление доступом к объектам.',
                icon: createIconWrapper(<DigitalConciergeIcon width={40} height={40} />),
                onDetails: () => setDigitalConciergePopup(true),
            },
            {
                key: 'rentysoft',
                title: 'RentySoft',
                description: 'Платформа для интеграции умных замков с Битрикс, Amo, Yclients, TravelLine, RealtyCalendar и другими системами. Универсальное решение для управления замками различных поставщиков. Подходит для краткосрочной аренды, коворкингов, мини-отелей.',
                icon: createIconWrapper(<img src={rentysoftIcon} alt="RentySoft" width={40} height={40} style={{objectFit: 'contain'}} />),
                onDetails: () => setRentySoftPopup(true),
            },
            {
                key: 'roomsharing',
                title: 'RoomSharing',
                description: 'Платформа для управления совместной арендой. Интеграция позволяет автоматически создавать договоры на основе данных из RoomSharing.',
                icon: createIconWrapper(<RoomSharingIcon width={40} height={40} />),
                onDetails: () => setRoomSharingPopup(true),
            },
        ],
    };

    return <>
        <div className="integrations-view ui-kit-v2" style={{paddingBottom: 24}}>
            {/* Секция: Прямая интеграция по API */}
            <div className="integrations-section">
                <div className="Subtitle_16" style={{marginTop: 0, marginBottom: 12}}>
                    Прямая интеграция по API
                </div>
                <div className="cells-list">
                    {integrations.api.map(({ key, ...card }) => (
                        <IntegrationCard key={key} {...card} />
                    ))}
                </div>
            </div>

            {/* Секция: PMS системы */}
            <div className="integrations-section">
                <div className="Subtitle_16" style={{marginTop: 32, marginBottom: 12}}>
                    PMS системы
                </div>
                <div className="cells-list">
                    {integrations.pms.map(({ key, ...card }) => (
                        <IntegrationCard key={key} {...card} />
                    ))}
                </div>
            </div>

            {/* Секция: CRM системы */}
            <div className="integrations-section">
                <div className="Subtitle_16" style={{marginTop: 32, marginBottom: 12}}>
                    CRM системы
                </div>
                <div className="cells-list">
                    {integrations.crm.map(({ key, ...card }) => (
                        <IntegrationCard key={key} {...card} />
                    ))}
                </div>
            </div>
            
            {/* Секция: Системы управления умными замками */}
            <div className="integrations-section">
                <div className="Subtitle_16" style={{marginTop: 32, marginBottom: 12}}>
                    Системы управления умными замками
                </div>
                <div className="cells-list">
                    {integrations.locks.map(({ key, ...card }) => (
                        <IntegrationCard key={key} {...card} />
                    ))}
                </div>
            </div>
        </div>


        {/* Попапы */}
        {apiIntegrationPopup &&
            <ApiIntegrationPopup close={() => setApiIntegrationPopup(false)} />
        }
        {realtyIntegrationPopup && (
            <RealtyIntegrationSetupPopup
                close={() => {setRealtyIntegrationPopup(false)}}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        )}
        {realtyIntegrationInfoPopup && (
            <RealtyIntegrationV2Popup
                close={() => {setRealtyIntegrationInfoPopup(false)}}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        )}
        {realtyOldIntegrationPopup && (
            <IncomingWebhookIntegrationPopup
                close={() => {setRealtyOldIntegrationPopup(false)}}
                serviceName={"RealtyCalendar"}
                helpView={
                    <HelpView
                        title={"Интеграция с RealtyCalendar"}
                        subtitle={helpViewDescription("RealtyCalendar") +
                            "\n" +
                            "Подробнее о том, как работает интеграция и как ее настроить, смотрите в нашем видео"}
                        videoId={"mQgx_BoDUtE"}
                        rutubeVideoId={"29f8592a82d8f3e8392b9870c70550b4"}
                    />
                }
                realtyConfig={props.$store.userSession.realty_integration}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        )}
        {/* {litePMSIntegrationPopup &&
            <IncomingWebhookIntegrationPopup
                close={() => {setLitePMSIntegrationPopup(false)}}
                serviceName={"Lite PMS"}
                helpView={
                    <HelpView
                        title={"Интеграция с Lite PMS"}
                        subtitle={helpViewDescription("Lite PMS") +
                            "\n" +
                            "Подробнее о том, как настроить интеграцию смотрите в инструкции:"}
                        externalLink={"https://litepms.ru/welcome/help?id=77"}
                        externalLinkTitle={"Инструкция по подключению"}
                    />
                }
                realtyConfig={props.$store.userSession.realty_integration}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        } */}
        {yclientsPopup &&
            <YclientsIntegrationPopup
                close={() => {setYclientsPopup(false)}}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
        {paraplanPopup &&
            <ParaplanIntegrationPopup
                close={() => {setParaplanPopup(false)}}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
        {amoIntegrationPopup &&
            <AmoCRMIntegrationPopup
                close={() => {setAmoIntegrationPopup(false)}}
                amoConfig={props.$store.userSession.amo_integration}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
        {bitrixIntegrationPopup &&
            <BitrixIntegrationPopup
                close={() => {setBitrixIntegrationPopup(false)}}
                bitrixConfig={props.$store.userSession.bitrix_integration}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
        {rentprogIntegrationPopup &&
            <RentProgIntegrationPopup
                close={() => {setRentprogIntegrationPopup(false)}}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
        {/* Попапы-заглушки для замков */}
        {digitalConciergePopup &&
            <LockIntegrationStubPopup 
                name="Digital Concierge" 
                close={() => setDigitalConciergePopup(false)}
                websiteUrl="https://dc.proptech.digital/"
                description="Система управления умными замками для арендного бизнеса. Автоматизация процессов заселения и выезда. Интеграция с различными PMS системами."
            />
        }
        {rentySoftPopup &&
            <LockIntegrationStubPopup 
                name="RentySoft" 
                close={() => setRentySoftPopup(false)}
                websiteUrl="https://rentysoft.com/"
                description="Платформа для интеграции умных замков с Битрикс, Amo, Yclients, TravelLine, RealtyCalendar и другими системами. Универсальное решение для управления замками различных поставщиков."
            />
        }
        {roomSharingPopup &&
            <RoomSharingIntegrationPopup
                close={() => {setRoomSharingPopup(false)}}
                serviceName={"RoomSharing"}
                helpView={
                    <HelpView
                        title={"Интеграция с RoomSharing"}
                        subtitle={`Платформа для управления совместной арендой. Система управления доступом к помещениям. Автоматизация процессов аренды. Интеграция позволяет автоматически создавать договоры на основе данных из RoomSharing.`}
                    />
                }
                roomsharingConfig={props.$store.userSession.realty_integration}
                $store={props.$store}
                $commitToStore={props.$commitToStore}
            />
        }
        {/* {bnovoPopup &&
            <LockIntegrationStubPopup 
                name="Bnovo" 
                close={() => setBnovoPopup(false)}
                websiteUrl="https://bnovo.ru"
                description="Система управления отелями и гостиницами. Автоматизация рутины и отчетов, усиление revenue, контроль загрузки и управление бронями в одном кабинете."
                integrationType="roomsharing"
            />
        }
        {travelLinePopup &&
            <LockIntegrationStubPopup 
                name="TravelLine" 
                close={() => setTravelLinePopup(false)}
                websiteUrl="https://www.travelline.ru/"
                description="Комплексная система управления отелями и туристическими объектами. Автоматизация бронирования, управления номерами и клиентами."
                integrationType="roomsharing"
            />
        } */}
    </>
}

IntegrationsView = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(IntegrationsView)

export default IntegrationsView
